import cx from 'clsx';
import {
  ActionIcon as MActionIcon,
  rem,
  type ActionIconCssVariables,
  type ActionIconProps,
  type MantineSize,
} from '@mantine/core';
import classes from './actionIcon.module.scss';

const defaultProps: Partial<ActionIconProps> = {
  variant: 'transparent',
  color: 'primary',
  size: 'sm',
};

const actionIconStyles: Record<
  MantineSize | string,
  Partial<Record<ActionIconCssVariables['root'], string>>
> = {
  xs: {
    '--ai-size': rem(30),
  },
  sm: {
    '--ai-size': rem(36),
  },
  md: {
    '--ai-size': rem(46),
  },
  lg: {
    '--ai-size': rem(50),
  },
  xl: {
    '--ai-size': rem(56),
  },
};

export const ActionIcon = MActionIcon.extend({
  defaultProps,
  classNames: (_theme, props) => ({
    root: cx(classes.root, {
      [classes[props.color || defaultProps.color!]]: true,
    }),
  }),
  vars: (_theme, props) => ({
    root: {
      '--ai-radius': rem(6),
      ...(actionIconStyles[props.size || defaultProps.size!] ?? {}),
    },
  }),
});
